import React, {useEffect, useState} from 'react';
import InputMask from 'react-input-mask';

export const InputMaskedIpAddress = ({
  title,
  required,
  minLength,
  defaultValue,
  value,
  disabled,
  id,
  placeholder,
  onChange,
  onChangeText,
  type = 'text',
  mask = 'IP',
  ...otherProps
}) => {
  const IP_MASK = '999.999.999.999';

  const [initialMask, setInitialMask] = useState(mask);

  const _onChange = (e) => {
    const inputValue = e.target.value;
    onChange && onChange(e);
    onChangeText && onChangeText(inputValue);
  };
  useEffect(() => {
    if (initialMask !== mask) {
      onChangeText && onChangeText('');
      setInitialMask(mask);
    }
  }, [mask, initialMask, onChangeText]);

  return (
    <div>
      <span className="text-bold">{title}</span>
      <InputMask
        type={type}
        mask={IP_MASK}
        value={value}
        minLength={minLength}
        required={required}
        defaultValue={defaultValue}
        disabled={disabled}
        className={`form-control mt-1 `}
        id={id}
        placeholder={placeholder}
        onChange={_onChange}
        {...otherProps}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/gateways/node/InputMaskedIpAddress.js